module.exports = __webpack_public_path__ + "img/device.92dbb1a8.png";